import Container, { gutterTypes } from '~/components/atoms/Container/Container'
import type { LinkProps } from '~/components/links'
import { resolveLink } from '~/components/serializers'
import type { ComponentTheme } from '~/components/themes'

import Button, { ButtonVariants } from '../Button/Button'
import Fixture from '../Fixture/Fixture'
import Text, { TextSizes } from '../Text/Text'

import styles from './TextColumnsWithLinks.module.css'

export interface ColumnItemProps {
  text: string
  link: LinkProps
}

export interface TextColumnsWithLinksProps {
  items: ColumnItemProps[]
  title: string
  theme?: ComponentTheme
  verticalPadding?: boolean
  noPaddingBottom?: boolean
  testID?: string
  moduleId?: string
}

export default function TextColumnsWithLinks({
  items,
  title,
  theme,
  verticalPadding,
  noPaddingBottom,
  testID,
  moduleId,
}: TextColumnsWithLinksProps) {
  return (
    <Fixture
      theme={theme}
      verticalPadding={verticalPadding}
      noPaddingBottom={noPaddingBottom}
      id={moduleId}
    >
      <Container gutters={gutterTypes.always}>
        <div className={styles.base} data-testid={testID}>
          <Text size={TextSizes.primaryTitleLrg} Tag="h3">
            {title}
          </Text>
          <div className={styles.colWrap}>
            {items.map((item, i) => {
              return (
                <div key={`column-text-${i}`} className={styles.textCol}>
                  <Text size={TextSizes.bodyMed} Tag="p">
                    {item.text}
                  </Text>
                  <Button
                    variant={ButtonVariants.textLink}
                    link={resolveLink({ ...item.link })}
                  >
                    <Text size={TextSizes.primaryTitleXSml}>
                      {item.link.text}
                    </Text>
                  </Button>
                </div>
              )
            })}
          </div>
        </div>
      </Container>
    </Fixture>
  )
}
